import { IAffiliateSubLink } from 'entities/Link';

export const getMappedLinks = (affiliateLinks: IAffiliateSubLink[] = []) => {
	return affiliateLinks.flatMap((affiliateLink) => [
		affiliateLink,
		...(affiliateLink.landings?.map((landing) => ({ ...affiliateLink, ...landing })) || []),
	]);
};
